import { useCallback } from "react";

type ButtonProps = {
  children: React.ReactNode;
  onClick?: () => void | Promise<void>;
  longPress?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

export const ViewMgtDeviceCommandButton = ({
  children,
  onClick,
  longPress,
  className = "",
  style = {},
}: ButtonProps) => {
  
  const longPressHandler = useCallback(() => {
    if (onClick) onClick();
  }, [onClick]);

  return (
    <button
      style={style}
      {...(longPress ? createLongPressHandler(longPressHandler, 1_000) : {})}
      className={`w-full px-3 py-1 border rounded-md text-sm font-medium bg-white text-[rgb(51,123,187)] transition active:scale-95 hover:shadow-md hover:bg-gray-50 ${className}`}
      onClick={!longPress ? onClick : undefined}
    >
      {children}
    </button>
  );
};

function createLongPressHandler(callback: () => void | Promise<void>, duration: number) {
  
  let pressTimer: NodeJS.Timeout;

  return {
    onMouseDown: () => (pressTimer = setTimeout(callback, duration)),
    onMouseUp: () => clearTimeout(pressTimer),
    onMouseLeave: () => clearTimeout(pressTimer),

    onTouchStart: () => (pressTimer = setTimeout(callback, duration)),
    onTouchEnd: () => clearTimeout(pressTimer),
  };
}
